import React from 'react';
import { Route } from 'react-router-dom';
import tableConfig from "../config/tableConfig";
// Import admin-specific components
import Dashboard from '../jsx/components/Dashboard/Home';
import Home from '../jsx/components/Dashboard/Home';
import { getAllSubCategory, getAllUserCategory, getAllUserLevel } from '../services/superadminService/UserLevel';
import CommonTable from '../jsx/components/CommonTable/CommonTable';
import CategoryTypeList from '../admin/admincomponent/categoryType/CategoryTypeList';
import SubCategoryList from '../admin/admincomponent/subCategory/SubCategoryList';
import OrganizationList from '../admin/admincomponent/organization/OrganizationList';
import IndividualList from '../admin/admincomponent/Individual/IndividualList';
import IndividualVerificationForm from '../admin/admincomponent/Individual/IndividualVerificationForm';
import OrganizationVerficationForm from '../admin/admincomponent/organization/OrganizationVerficationForm';
import VerifiedUserList from '../admin/admincomponent/verifiedUser/VerifiedUserList';
import viewUser from '../admin/admincomponent/verifiedUser/ViewUser';
import ViewUser from '../admin/admincomponent/verifiedUser/ViewUser';



export const allAdminroutes = [
  /// Dashboard
  { url: "", component: <Home/> },
  { url: "dashboard", component: <Home /> },
  { url: "Organization", component: <OrganizationList/> },
  { url: "Individual", component: <IndividualList/> },
  { url: "verification-form/:id", component: <OrganizationVerficationForm/> },
  { url: "verification-Individual-form/:id", component: <IndividualVerificationForm/> },
  { url: "verified-insitute-user", component: <VerifiedUserList roletype="2" roleCategory="insitute"/> },
  { url: "verified-individual-user", component: <VerifiedUserList roletype="1" roleCategory="individual"/> },
  { url: "verification-view-form/:id", component: <ViewUser/> },

  // { url: 'user-category', component: <CommonTable fetchData={getAllUserCategory} config={tableConfig['user-category']} /> },
  // { url: 'user-sub-category', component: <SubCategoryList  /> },
  // { url: 'user-category-type', component: <CategoryTypeList /> },
  

  

];